import { render, staticRenderFns } from "./DetailActiveOrders.vue?vue&type=template&id=6b767c48"
import script from "../../script/orders/detailActiveOrder.js?vue&type=script&lang=js&external"
export * from "../../script/orders/detailActiveOrder.js?vue&type=script&lang=js&external"
import style0 from "../../less/orders/detailOrder.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports